// extracted by mini-css-extract-plugin
module.exports = {"header":"alert-component_header__3N6-e","msg":"alert-component_msg__2urm5","positiveButton":"alert-component_positiveButton__61XId","actions":"alert-component_actions__1uHam"};